import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SpitiExpedition from "../FillerComponents/SpitiExpedition";

const locations = [
  {
    name: "Himachal Pradesh",
    visited: "70k Customers",
    image:
      "https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=1200&auto=format&fit=crop",
    route: "/himachalpradesh",
  },
  {
    name: "Jammu & Kashmir",
    visited: "25k Customers",
    image:
      "https://s3.india.com/wp-content/uploads/2025/04/Jammu-Kashmir-Tourism-Update.jpg",
    route: "/jammu&kashmir",
  },
  {
    name: "Ladakh",
    visited: "14k Customers",
    image:
      "https://www.sostravelhouse.com/public/uploads/images/location/674967fa9f17e.webp",
    route: "/leh&ladakh",
  },
  {
    name: "Uttarakhand",
    visited: "60k Customers",
    image:
      "https://uttarakhandtourism.net/wp-content/uploads/2023/12/badrinath_page-600x540.jpg",
    route: "/uttarakhand",
  },
];

export default function TopRatedLocations() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);

  return (
    <Box sx={{ py: 10, px: { xs: 3, md: 6 }, backgroundColor: "#f8f9fa" }}>
      {/* Heading */}
      <Box textAlign="center" mb={8}>
        <Typography
          variant="overline"
          sx={{ letterSpacing: 3, fontWeight: 700, color: "#6c757d" }}
        >
          Explore The World
        </Typography>

        <SpitiExpedition/>

        <Typography
          variant="h2"
          fontWeight={900}
          sx={{
            background: "linear-gradient(45deg, #ff6a00, #ee0979)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 2,
            fontSize: { xs: "2.4rem", md: "3.4rem" }
          }}
        >
          Top Rated Locations
        </Typography>

        <Typography color="text.secondary" maxWidth={600} mx="auto">
          Discover the most breathtaking destinations curated for your next adventure.
        </Typography>
      </Box>

      {/* Cards */}
      <Grid container spacing={4}>
        {locations.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              whileHover={{ y: -12 }}
            >
              <Card
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  navigate(item.route);
                }}
                sx={{
                  height: 500,
                  borderRadius: "22px",
                  overflow: "hidden",
                  position: "relative",
                  cursor: "pointer",
                  boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
                }}
              >
                {/* Image */}
               
                <CardMedia
                  component="img"
                  image={item.image}
                  alt={item.name}
                  sx={{
                    height: "100%",
                    width: "100%",
                    transition: "transform 0.8s ease",
                    transform: hovered === index ? "scale(1.12)" : "scale(1)",
                  }}
                />

                {/* Dark gradient */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.85) 15%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0) 100%)",
                    zIndex: 1,
                  }}
                />

                {/* CENTER CTA OVERLAY */}
                <motion.div
                  animate={{ opacity: hovered === index ? 1 : 0 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0,0,0,0.45)",
                    pointerEvents: hovered === index ? "auto" : "none",
                  }}
                >
                  <Button
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1.2,
                      fontWeight: 700,
                      textTransform: "none",
                      background: "#fff",
                      color: "#ff6a00",
                      "&:hover": {
                        background: "#ff6a00",
                        color: "#fff",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      navigate(item.route);
                    }}
                  >
                    Click to Explore
                  </Button>
                </motion.div>

                {/* Bottom content */}
                <CardContent
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    zIndex: 2,
                    color: "#fff",
                    p: 3,
                  }}
                >
                  <Chip
                    label={item.visited}
                    sx={{
                      mb: 2,
                      backgroundColor: "rgba(255,255,255,0.15)",
                      color: "#fff",
                      backdropFilter: "blur(6px)",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  />

                  <Typography
                    variant="h4"
                    fontWeight={800}
                    sx={{ lineHeight: 1.1 }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
